export function libsBackendUtils(): string {
    return 'libs-backend-utils';
}